enum PatrimonyPromotionTypeEnum {
    ASSIGNMENT = 'ASSIGNMENT',
    DONATION = 'DONATION',
    PURCHASE = 'PURCHASE',
}

export default PatrimonyPromotionTypeEnum;
